import {
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress
} from '@mui/material';
import { connect } from 'redux-bundler-react';
import { withStyles } from 'tss-react/mui';
import React from 'react';

const styles = theme => ({});

const SsmLoadingDialog = ({ classes, workstation, session, open, onClose }) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      aria-labelledby="confirmation-dialog-title"
      open={open}
    >
      <DialogTitle className={classes.dialogTitle}>Connecting</DialogTitle>

      <DialogContent className={classes.content}>
        <LinearProgress />
      </DialogContent>
    </Dialog>
  );
};

export default connect(
  'selectRecipeQueryParameter',
  'selectActiveImagePipeline',
  withStyles(SsmLoadingDialog, styles),
);
